/** @jsx jsx */

import { Fragment } from 'react';

import { Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    font-weight: 700;
    font-size: 16px;
  `,
};

type Props = {
  'aria-invalid'?: boolean;
  description?: string;
  htmlFor?: string;
  isRequired?: boolean;
  title: string;
};

function Label({
  'aria-invalid': ariaInvalid,
  description,
  htmlFor,
  isRequired,
  title,
}: Props) {
  return (
    <label aria-invalid={ariaInvalid} css={Styles.root} htmlFor={htmlFor}>
      {description && (
        <Text margin="0 0 20px" tag="p" type="Body1">
          {description}
        </Text>
      )}
      {title && (
        <Fragment>
          <Text tag="span" type="SmallPrint3">
            {isRequired && '* '}
            {title}
          </Text>
          <Text tag="span">{isRequired && ' (required)'}</Text>
        </Fragment>
      )}
    </label>
  );
}

export default Label;
